<template>
  <div
    class="component-landing-subscription"
    :style="{'background-color': configurations.backgroundColor}"
  >
    <!-- Enter phone number -->
    <div v-if="uiState == SubscriptionUIState.InputPhoneNumber">
      <h3
        v-if="!configurations.enterPhoneNumberMessage.startsWith('<')"
        class="enter-phone-message"
      >
        {{ configurations.enterPhoneNumberMessage }}
      </h3>
      <pre
        v-if="configurations.enterPhoneNumberMessage.startsWith('<')"
        v-html="configurations.enterPhoneNumberMessage"
      />

      <div id="phone" ref="cellNumberWrapper" class="input_container animated">
        <div class="input-prepend">
          <svg
            id="Capa_1"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="35px"
            height="35px"
            viewBox="0 0 35 35"
            style="enable-background:new 0 0 35 35;"
            xml:space="preserve"
          >
            <g>
              <path
                d="M25.302,0H9.698c-1.3,0-2.364,1.063-2.364,2.364v30.271C7.334,33.936,8.398,35,9.698,35h15.604
                    c1.3,0,2.364-1.062,2.364-2.364V2.364C27.666,1.063,26.602,0,25.302,0z M15.004,1.704h4.992c0.158,0,0.286,0.128,0.286,0.287
                    c0,0.158-0.128,0.286-0.286,0.286h-4.992c-0.158,0-0.286-0.128-0.286-0.286C14.718,1.832,14.846,1.704,15.004,1.704z M17.5,33.818
                    c-0.653,0-1.182-0.529-1.182-1.183s0.529-1.182,1.182-1.182s1.182,0.528,1.182,1.182S18.153,33.818,17.5,33.818z M26.021,30.625
                    H8.979V3.749h17.042V30.625z"
              />
            </g>
          </svg>
        </div>
        <input
          ref="cellNo"
          v-model="phoneNumber"
          :placeholder="configurations.phoneNumberPlaceholder"
          pattern="[0-9]"
          name="phoneNumber"
          type="tel"
          @input="checkPhoneNumberLength"
        >
      </div>

      <p v-show="showPhoneNumberError" class="alert">
        {{ configurations.invalidPhoneNumberMessage }}
      </p>

      <div
        v-if="!configurations.headerText.startsWith('<')"
        class="info"
      >
        {{ configurations.headerText }}
      </div>

      <pre v-if="configurations.headerText.startsWith('<')" v-html="configurations.headerText" />

      <button
        id="register"
        ref="register"
        class="button register"
        :class="configurations.subscribtionButtonType + ' ' + configurations.subscribtionButtonAccent + ' ' + configurations.subscribtionButtonBorderAccent + ' ' + configurations.subscribtionButton‌BorderType + ' ' + configurations.subscribtionButton‌BorderRadius + ' ' + configurations.subscribtionButton‌BorderWidth + ' animated ' + configurations.subscribtionButtonAnimationCount + ' ' + configurations.subscribtionButtonAnimation + ' ' + configurations.subscribtionButtonAnimationDelay + ' ' + configurations.subscribtionButtonAnimationSpeed"
        @click="initSubscription"
      >
        <span>{{ configurations.subscribeButtonText }}</span>
      </button>
    </div>

    <!-- confirm phone number -->
    <div v-if="uiState == SubscriptionUIState.InputConfirmationCode">
      <h3>{{ configurations.enterConfirmationCodeMessage }}</h3>

      <div ref="pinCodeWrapper" class="input_container animated">
        <input
          ref="pinCode"
          v-model="verificationCode"
          class="pin-code"
          :placeholder="configurations.pinPlaceholder"
          pattern="[0-9]"
          type="tel"
          name="confirmationCode"
          maxlength="6"
        >
      </div>
      <div v-if="errorMessage" class="alert alert-danger mt-3 text-white font-size-small" role="alert">
        {{ errorMessage }}
      </div>

      <button
        id="confirm"
        class="button"
        :class="configurations.confirmButtonType + ' ' + configurations.confirmButtonAccent + ' ' + configurations.confirmButtonBorderAccent + ' ' + configurations.confirmButton‌BorderType + ' ' + configurations.confirmButton‌BorderRadius + ' ' + configurations.confirmButton‌BorderWidth + ' animated ' + configurations.confirmButtonAnimationCount + ' ' + configurations.confirmButtonAnimation + ' ' + configurations.confirmButtonAnimationDelay + ' ' + configurations.confirmButtonAnimationSpeed"
        @click="verifyOtp"
      >
        <span>{{ configurations.verifyButtonText }}</span>
      </button>
    </div>

    <!-- Subscription confirmed -->
    <div v-if="uiState == SubscriptionUIState.Confirmed" class="success messageBox slideTop">
      <span>{{ configurations.subscriptionSucceededMessage }}</span>
    </div>

    <!-- Subscription failed -->
    <div v-if="uiState == SubscriptionUIState.Failed" class="alert messageBox slideTop">
      <span>{{ configurations.subscriptionFailedMessage }}</span>
    </div>

    <!-- Footer -->
    <div>
      <div v-if="configurations.footerText !== ''" class="footer">
        <span v-if="!configurations.footerText.startsWith('<')">
          {{ configurations.footerText }}
        </span>
        <pre v-if="configurations.footerText.startsWith('<')" v-html="configurations.footerText" />
      </div>
      <a
        class="conditions"
        :href="configurations.rulesUrl"
        target="_blank"
      >
        {{ configurations.rulesText }}
      </a>
    </div>

    <div
      v-if="uiState == SubscriptionUIState.SendingRequest || (uiState == SubscriptionUIState.WaitingForProcessing)"
      class="loadingWrapper"
    >
      <div class="preloader loading">
        <span class="slice" />
        <span class="slice" />
        <span class="slice" />
        <span class="slice" />
        <span class="slice" />
        <span class="slice" />
      </div>

      <!-- Sending Request -->
      <h3 v-if="uiState == SubscriptionUIState.SendingRequest" class="loadingMessage">
        <span>{{ $t('landing.sendingRequest') }}</span>
      </h3>

      <!-- Waiting for Processing -->
      <h3 v-if="uiState == SubscriptionUIState.WaitingForProcessing" class="loadingMessage">
        <pre>{{ $t('landing.waitingForProcessing') }}</pre>
        <span>{{ $t('landing.status') }}</span>
        <span>{{ statusText }}</span>
      </h3>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import utility from '@/utilities/utility'

export default Vue.extend({
  name: 'SectionSubscription',
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      phoneNumber: '',
      verificationCode: '',
      errorMessage: '',
      showPhoneNumberError: false,
      isSendingRequest: false,
      isAnythingFailed: false,
      phoneNumberValidationRegex: null,
      SubscriptionUIState: {
        SendingRequest: 0,
        InputPhoneNumber: 1,
        WaitingForProcessing: 2,
        InputConfirmationCode: 3,
        Confirmed: 4,
        Failed: 5
      },
      LandingPageSessionEventType: {
        PageVisited: 1,

        SendingSubRequestSucceeded: 101,
        SendingSubRequestFailed: 102,
        SubRequestFailedBeforeConfirm: 103,
        ConfirmationCodeSent: 104,
        SendingConfirmRequestSucceeded: 105,
        SendingConfirmRequestFailed: 106,
        InvalidConfirmationCode: 107,
        SubscriptionSucceeded: 108,
        SubscriptionFailed: 109,

        SendingUnsubRequestSucceeded: 111,
        SendingUnsubRequestFailed: 112,
        UnsubscriptionSucceeded: 113,
        UnsubscriptionFailed: 114
      }
    }
  },
  computed: {
    ...mapGetters({
      requestStatus: 'landingPage/requestStatus',
      validCountryCode: 'landingPage/validCountryCode',
      validPhoneNumberLength: 'landingPage/validPhoneNumberLength',
      headerUsername: 'landingPage/headerUsername'
    }),
    statusText () {
      switch (this.requestStatus) {
        case 'None':
          return this.$t('landing.subscriptionStatus.None')
        case 'Init':
          return this.$t('landing.subscriptionStatus.Init')
        case 'Processing':
          return this.$t('landing.subscriptionStatus.Processing')
        case 'AwaitingVerification':
          return this.$t('landing.subscriptionStatus.AwaitingVerification')
        case 'Verified':
          return this.$t('landing.subscriptionStatus.Verified')
        case 'FailedVerification':
          return this.$t('landing.subscriptionStatus.FailedVerification')
        case 'CheckPolicy':
          return this.$t('landing.subscriptionStatus.CheckPolicy')
        case 'Finalized':
          return this.$t('landing.subscriptionStatus.Finalized')
        case 'Failed':
          return this.$t('landing.subscriptionStatus.Failed')
        default:
          return ''
      }
    },
    uiState () {
      if (this.isAnythingFailed) {
        return this.SubscriptionUIState.Failed
      } else if (this.isSendingRequest) {
        return this.SubscriptionUIState.SendingRequest
      } else {
        switch (this.requestStatus) {
          case 'None':
            return this.SubscriptionUIState.InputPhoneNumber
          case 'Init':
            return this.SubscriptionUIState.WaitingForProcessing
          case 'Processing':
            return this.SubscriptionUIState.WaitingForProcessing
          case 'AwaitingVerification':
            return this.SubscriptionUIState.InputConfirmationCode
          case 'Verified':
            return this.SubscriptionUIState.WaitingForProcessing
          case 'FailedVerification':
            return this.SubscriptionUIState.InputConfirmationCode
          case 'CheckPolicy':
            return this.SubscriptionUIState.WaitingForProcessing
          case 'Finalized':
            return this.SubscriptionUIState.Confirmed
          case 'Failed':
            return this.SubscriptionUIState.Failed
        }
      }

      return this.SubscriptionUIState.InputPhoneNumber
    },
    fixedEncodingPhoneNumber () {
      return this.getFixedNumberEncoding(this.phoneNumber)
    },
    fixedEncodingVerificationCode () {
      return this.getFixedNumberEncoding(this.verificationCode)
    }
  },
  mounted () {
    this.phoneNumberValidationRegex = new RegExp(
      '(^' + this.validCountryCode + '[1-9]{1}[0-9]{' + (this.validPhoneNumberLength - 1).toString() + '}$)|' +
      '(^0' + this.validCountryCode + '[1-9]{1}[0-9]{' + (this.validPhoneNumberLength - 1).toString() + '}$)|' +
      '(^00' + this.validCountryCode + '[1-9]{1}[0-9]{' + (this.validPhoneNumberLength - 1).toString() + '}$)|' +
      '(^0[1-9]{1}[0-9]{' + (this.validPhoneNumberLength - 1).toString() + '}$)|' +
      '(^[1-9]{1}[0-9]{' + (this.validPhoneNumberLength - 1).toString() + '}$)'
    )
    this.tryFetchPhoneNumber()
  },
  methods: {
    ...mapActions({
      init: 'landingPage/init',
      verify: 'landingPage/verify'
    }),
    tryFetchPhoneNumber () {
      let userUniqueIdentifier = utility.getQueryStringValue(
        'useruniqueidentifier'
      )
      if (userUniqueIdentifier) {
        this.phoneNumber = userUniqueIdentifier
      }

      let userName = utility.getQueryStringValue('username')
      if (userName) {
        this.phoneNumber = userName
      }

      let phoneNumber = utility.getQueryStringValue('phonenumber')
      if (phoneNumber) {
        this.phoneNumber = phoneNumber
      }

      let msisdn = utility.getQueryStringValue('msisdn')
      if (msisdn) {
        this.phoneNumber = msisdn
      }

      if (this.headerUsername) {
        this.phoneNumber = this.headerUsername
      }
    },
    checkPhoneNumberLength () {
      this.showPhoneNumberError = false

      let registerButton = this.$refs.register
      var element = this.$refs.cellNo
      var length = element.value.length
      let buttonColor = registerButton.classList.contains('green')
        ? '153, 204, 102'
        : '82, 170, 204'
      // registerButton.style = 'background: rgba(' + buttonColor + ',' + (length + 2) / 10 +'); border: inset 5px rgba(255, 255, 255,' + (length + 2) / 10 + ')'

      if (this.phoneNumberValidationRegex.test(this.fixedEncodingPhoneNumber)) {
        registerButton.classList.add('shadow')
      } else {
        registerButton.classList.remove('shadow')
      }
    },
    initSubscription () {
      // TODO: Validate phone number
      let element = this.$refs.cellNo
      let length = element.value.length

      if (
        !this.phoneNumberValidationRegex.test(this.fixedEncodingPhoneNumber)
      ) {
        // Phone number is invalid
        this.showPhoneNumberError = true

        let inputWrapper = this.$refs.cellNumberWrapper
        inputWrapper.classList.add('tada')
        setTimeout(() => {
          inputWrapper.classList.remove('tada')
        }, 1000)
      } else {
        this.showPhoneNumberError = false

        this.sendInitRequest()
      }
    },
    sendInitRequest () {
      let payload = {
        deviceType: 'None',
        userName: this.fixedEncodingPhoneNumber,
        isEmail: false
      }

      this.isSendingRequest = true
      this.init(payload).then(
        response => {
          this.isSendingRequest = false
        },
        error => {
          if (
            error.body.error.message !== 'Paroo.Subscription.AlreadySubscribed'
          ) {
            this.isSendingRequest = false
            if (error) {
              this.isAnythingFailed = true
            }
          }
        }
      )
    },
    verifyOtp () {
      let element = this.$refs.pinCode
      let length = element.value.length

      if (length < 4) {
        let inputWrapper = this.$refs.pinCodeWrapper
        inputWrapper.classList.add('tada')
        setTimeout(() => {
          inputWrapper.classList.remove('tada')
        }, 1000)
      } else {
        this.sendVerifyRequest()
      }
    },
    sendVerifyRequest () {
      this.isSendingRequest = true
      this.errorMessage = null

      this.verify(this.fixedEncodingVerificationCode).then(
        response => {
          var result = response.body.result
          if (result.status === 'Expired') {
            this.errorMessage = this.$t('validations.messages.pinExpired')
          } else if (result.status === 'MaxRetryReached') {
            this.errorMessage = this.$t(
              'validations.messages.pinMaxRetryReached'
            )
          } else if (result.status === 'Failed') {
            this.errorMessage = this.$t('validations.messages.wrongPinCode')
          }
          this.isSendingRequest = false
        },
        error => {
          if (error) {
            this.isSendingRequest = false
          }
        }
      )
    },
    getFixedNumberEncoding (str) {
      let persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g
      ]
      let arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g
      ]
      let result = str
      for (let i = 0; i < 10; i++) {
        result = result
          .replace(persianNumbers[i], i)
          .replace(arabicNumbers[i], i)
      }
      return result
    }
  }
})
</script>
